import { render, staticRenderFns } from "./be-partner-with-us.vue?vue&type=template&id=ff7c7794&scoped=true"
import script from "./be-partner-with-us.vue?vue&type=script&lang=js"
export * from "./be-partner-with-us.vue?vue&type=script&lang=js"
import style0 from "./be-partner-with-us.vue?vue&type=style&index=0&id=ff7c7794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7c7794",
  null
  
)

export default component.exports